document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.aura-product-grid').forEach(grid => {

    const products = [...grid.querySelectorAll('.aura-product-grid__item')];

    const section = grid.closest('.aura-section');

    if (!section) return;

    const actions = section.querySelector('.aura-product-grid__actions');

    if (!actions) return;

    const loadButton = actions.querySelector('.aura-load-more-button');
    const viewAllButton = actions.querySelector('.aura-view-all-button');

    if (!loadButton) return;

    const perLoad = Number(loadButton.dataset.productsPerLoad) || 4;

    const initialVisible =
  Number(grid.dataset.initialProducts) || perLoad;

    let visible = initialVisible;

    /* Reveal pattern (web + mobile): initial batch → one "+perLoad" batch →
       then ALL. First click loads one more batch; any further click reveals
       everything (updateGrid then hides Load More / shows View All). */
    let firstLoadDone = false;

    function updateGrid() {

      products.forEach((product, index) => {

        if (index < visible) {

  if (product.hasAttribute('hidden')) {

    product.classList.add('is-revealing');

    product.removeAttribute('hidden');

    requestAnimationFrame(() => {

      product.classList.remove('is-revealing');

    });

  }

} else {

  product.setAttribute('hidden', '');

}

      });

      if (visible >= products.length) {

        loadButton.hidden = true;

        if (viewAllButton) {
          viewAllButton.hidden = false;
        }

      }

    }

    updateGrid();

    loadButton.addEventListener('click', () => {

      if (!firstLoadDone) {
        visible += perLoad;
        firstLoadDone = true;
      } else {
        visible = products.length;
      }

      updateGrid();

    });

  });

});
